import { render } from "./updateTrip.vue?vue&type=template&id=57df1936&scoped=true"
import script from "./updateTrip.vue?vue&type=script&lang=js"
export * from "./updateTrip.vue?vue&type=script&lang=js"

import "./updateTrip.vue?vue&type=style&index=0&id=57df1936&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57df1936"]])

export default __exports__